<template>
  <section class="button-group">
    <span>您可以选择：</span>
    <a :href="url + '/expenses/order-list/1'" target="_blank" style="color: #1fb09f;">返回订单列表</a>
    <a href="/" target="_blank" style="color: #1fb09f;">返回首页</a>
  </section>
</template>
<script>
export default {
  props: ['config', 'orderCode'],
  data () {
    return {
      url:__vipOrderUrl
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/Payment/components/private-component/PaySuccessBtn.vue